import { FieldSchema } from "../../../Schema";

export const cluster: FieldSchema = {
  name: "cluster",
  grid: {
    displayed: true,
    order: 35,
  },
  display: {
    displayed: true,
  },
  form: { label: "Cluster" },
};
